// Citation — the inline [n] marker that apps drop into cited content. Presentational: an app
// renders <Citation index={1} role="cited" onActivate={…}/> and composes it with a popover at the
// mount. Tone distinguishes a CITED chunk (accent — actually used) from a merely-RETRIEVED one
// (muted — in the context set but not cited), mirroring the DF-4 cited ⊆ retrieved contract.
import type { ChunkRole } from "./types";

export interface CitationProps {
  index: number;
  role: ChunkRole;
  /** Marks the marker as currently open (its popover is showing). */
  active?: boolean;
  onActivate?: () => void;
}

export function Citation({ index, role, active, onActivate }: CitationProps): React.ReactElement {
  const cited = role === "cited";
  return (
    <button
      type="button"
      onClick={onActivate}
      aria-label={`Citation ${index} — ${cited ? "cited" : "retrieved"}`}
      aria-expanded={active ?? undefined}
      data-role={role}
      className={
        "inline-flex h-4 min-w-4 items-center justify-center rounded-[2px] px-1 align-baseline " +
        "text-[10px] font-semibold leading-none tabular-nums transition-colors " +
        (cited
          ? "bg-[var(--color-accent)] text-[var(--color-text-inverse)] hover:opacity-90"
          : "bg-[var(--color-surface-muted)] text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)]") +
        (active ? " ring-1 ring-[var(--color-accent)]" : "")
      }
    >
      {index}
    </button>
  );
}
